import authApi from '@/api/auth'
import { getToken, setToken, removeToken } from '@/utils/auth'

const state = {
  token: getToken(),
  userInfo: {},
  roles: [],
  permissions: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions
  }
}

const actions = {
  // 用户登录
  loginByCode({ commit }, userInfo) {
    const { phone, code } = userInfo
    return new Promise((resolve, reject) => {
      authApi.login({ phone, code }).then(response => {
        console.log('loginByCode登录成功，返回数据：', response)
        const { data } = response
        commit('SET_TOKEN', data.token)
        setToken(data.token)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
 loginByPwd({ commit }, userInfo) {
    const { account, pwd } = userInfo
    return new Promise((resolve, reject) => {
      authApi.loginByPwd({ account, pwd}).then(response => {
         console.log('response登录成功，返回数据：', response);
        const { data } = response
        commit('SET_TOKEN', data.token)
        setToken(data.token)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取用户信息
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getInfo().then(response => {
        const { data } = response
        
        if (!data) {
          reject('验证失败，请重新登录')
        }
        
        const { roles, permissions, ...userInfo } = data
        
        // 角色必须是非空数组
        if (!roles || roles.length <= 0) {
          reject('用户角色不能为空')
        }
        
        commit('SET_ROLES', roles)
        commit('SET_PERMISSIONS', permissions)
        commit('SET_USER_INFO', userInfo)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 退出登录
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      logout().then(() => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        commit('SET_PERMISSIONS', [])
        commit('SET_USER_INFO', {})
        removeToken()
        
        // 重置访问过的视图
        commit('app/DEL_ALL_VISITED_VIEWS', null, { root: true })
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 前端登出（无API调用）
  logoutFront({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      commit('SET_PERMISSIONS', [])
      commit('SET_USER_INFO', {})
      removeToken()
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}